import { Stack, Typography } from '@mui/material'
import { DataGrid } from 'Components/LifeDataGrid'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { convertToUserDateFormate } from 'utils/helpers'

function ListTop({ operations, setEventViewF }) {
  const siteUser = useSelector((store) => store.user)

  const columns = [
    // { field: 'id', headerName: 'ID', width: 90 },

    {
      field: 'ScheduleDate',
      headerName: 'Date',
      width: 110,
      editable: false,
      valueGetter: (params) => convertToUserDateFormate(siteUser.user, params.row.ScheduleDate),
    },

    {
      field: 'MaintenanceOperation',
      headerName: 'Opérations',
      width: 350,
      editable: true,
      // valueGetter: (params) => `${params.row.Marques.Marque}`,
    },
  ]
  return (
    <div
      style={{
        height: 350,
        width: '100% ',
        background: 'white',
        borderRadius: '5px',
      }}
    >
      <Typography
        variant="h6"
        sx={{
          flex: '1 1 100%',
          id: 'tableTitle',
          fontWeight: 600,
          padding: '10px',
          component: 'div',
        }}
      >
        Entretien planifié({operations.count})
      </Typography>

      <DataGrid
        sx={{ height: '85%', '.MuiDataGrid-footerContainer': { display: 'none' } }}
        rows={operations.results ? operations.results : []}
        columns={columns}
        // pageSize={rows}
        // rowCount={operations.count ? operations.count : 0}
        // onPageSizeChange={handleRowsChange}
        // onPageChange={handlePageChange}
        // rowsPerPageOptions={[ 10, 20, 40, 80, 100 ]}
        // pagination
        // onSelectionModelChange={itm => setSelectedRows( [ ...itm ] )}
        // paginationMode='server'
        // disableSelectionOnClick
        // checkboxSelection
        // disableSelectionOnClick
        onRowClick={(e) => setEventViewF(e.row.Event)}

        // onRowClick={(params, event) => {
        //   if (event.target.localName === 'div') {
        //     // window.open(params.row.Lien)
        //     navigate(`/domicile/vehicule/{}`)
        //   }
        // }}
      />
    </div>
  )
}
export default ListTop
